import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import ImageCarousel from "../components/ImageCarousel";
import SeasonSection from "../layouts/SeasonLayout";
import FAQAccordion from "../components/FAQAccordion";
import HompageFaqs from "../data/HompageFaqs";
import CardCarousel from "../components/CardCarousel";
import SubscribeNowBanner from "../components/SubscribeNowBanner";
import FacultyList from "../data/FacultyList";
import { Helmet } from 'react-helmet-async';
import { FaAngleDoubleDown } from "react-icons/fa";

const Home = () => {
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => setOffsetY(window.scrollY);
  const scrollToContent = () => {
    const section = document.getElementById("session-tabs");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  const [isWhiteSlide, setIsWhiteSlide] = useState(false);
  return (
    <>
      <Helmet>
        <title>Home - Art India Education</title>
      </Helmet>
      <main>
      <Navbar isWhiteSlide={isWhiteSlide} />
      <ImageCarousel onSlideChange={setIsWhiteSlide} />
         {/* ⬇️ Double Down Arrow */}
         <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-30 text-white animate-bounce">
            <FaAngleDoubleDown size={32} />
          </div>
          <button
            onClick={scrollToContent}
            className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-30 text-white animate-bounce"
            aria-label="Scroll to content"
          >
            <FaAngleDoubleDown size={32} />
          </button>
        <div id="explore" className="relative p-10 bg-[rgb(234,126,93)]">
          <section className="text-center py-16 px-6 ">
            <h2 className="text-4xl font-bold text-white text-bold  font-['EB_Garamond','Nunito','sans-serif']">
              ART INDIA EDUCATION
            </h2>
            <h3 className="text-2xl  mt-2 text-white text-bold font-semibold">
              AN ONLINE LEARNING PLATFORM
            </h3>
            <p className="text-lg text-white  max-w-3xl mx-auto mt-4">
              Art India Education seeks to expand on the vision of Art India Magazine and
              serves as an educational arm that will encourage inquiry-based and visually engaging
              learning for future stakeholders of art.
            </p>
          </section>
        </div>
       
        <section id="session-tabs">
        <SeasonSection
          seasonTitle="SEASON ONE"
          description={{
            title: "India’s Greatest Art Collective or Is It? – The Progressive Artists’ Group (PAG) and its Contexts",
            subtitle: "Discover perspectives & stories, nuanced histories & anecdotes related to the Progressive Art Movement and the development of Indian Modern Art.",
          }}
          seasonName = "season-one-episodes"
          episodes={[
            {
              title: "Episode One Trailer",
              subtitle: "A Window into the Modern: Unpacking the PAG",
              videoUrl: "https://player.vimeo.com/video/682850108?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
            },
            {
              title: "Episode Two Trailer",
              subtitle: "The Still and Quivering Centre: Close Reading of S. H. Raza",
              videoUrl: "https://player.vimeo.com/video/676175858?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
            },

          ]}
        />
        </section>

        <SeasonSection
          seasonTitle="SEASON TWO"
          description={{
            title: "Discovering and Delving into Indian Contemporary Art",
            subtitle: "Discover contemporary Indian art's diverse narratives, forms & styles, established & emerging artists, and its social, political & historical contexts – presented by leading experts in the space.",
          }}
          seasonName = "season-two-episodes"
          episodes={[
            {
              title: "Episode One Trailer",
              subtitle: "Newness and Nowness: Introducing Contemporary Art",
              videoUrl: "https://player.vimeo.com/video/811220210?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
            },
            {
              title: "Episode Two Trailer",
              subtitle: "The Still and Quivering Centre: Close Reading of S. H. Raza",
              videoUrl: "https://player.vimeo.com/video/811312036?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
            },

          ]}
        />

        <SubscribeNowBanner />

        <section className="pl-20 pt-16 pr-20">
          <h2 className="text-4xl font-bold text-black font-['EB_Garamond','Nunito','sans-serif']">
            OUR <span className="font-bold relative text-[rgb(234,126,93)] after:content-[''] after:block after:h-[3px] after:w-full after:bg-[rgb(234,126,93)] after:mt-1">FACULTY</span>
          </h2>
          <p className="text-lg text-black mt-4">
            Learn from industry experts including noted art historians, curators, collectors, scholars and art practitioners with experience and learning in the arts of India.
          </p>
        </section>
        <div className="pl-10 pr-10">
          <CardCarousel list={FacultyList} />
        </div>
        <section className="pl-20 pt-16 pr-20">
          <h2 className="text-4xl font-bold text-black font-['EB_Garamond','Nunito','sans-serif']">
            FREQUENTLY ASKED <span className="font-bold relative text-[rgb(234,126,93)] after:content-[''] after:block after:h-[3px] after:w-full after:bg-[rgb(234,126,93)] after:mt-1">QUESTIONS</span>
          </h2>
        </section>

        <div className="pb-12">
          <FAQAccordion faqs={HompageFaqs} />
        </div>
      </main>

    </>
  );
};
export default Home;